import React from 'react'
import styled from 'styled-components'
import { dimensions, light, spacing } from '~/constants/theme'

import Text, { FontStyle } from './Text'

const FilterOptionWrapper = styled.div`
  display: flex;
  gap: ${spacing.spacingMD};
  width: 100%;
`

const FilterOption = styled.div<{ selected?: boolean }>`
  align-items: center;
  display: flex;
  justify-content: center;
  flex: 1;
  border-radius: ${dimensions.borderRadiusSM};
  padding: ${spacing.spacingMD};
  background: ${({ selected }) => (selected ? light.gray400 : light.gray200)};
  cursor: pointer;
  transition: background ease-in-out 200ms;

  ${({ selected }) =>
    !selected
      ? ` &:hover {
    background: ${light.gray300};
  } `
      : ''}

  ${({ selected }) =>
    !selected
      ? ` &:active {
    background: ${light.dark600};
  } `
      : ''}
`
export interface FilterOption<V extends string | number = string | number> {
  default?: boolean
  label: string
  subLabel?: string
  value: V
}

interface FilterMenuProps<V extends string | number = string | number> {
  options: FilterOption<V>[]
  onChange: (value: V) => void
  selectedFilter?: V
}

const FilterMenu = <V extends string | number = string | number>({
  options,
  onChange,
  selectedFilter,
}: FilterMenuProps<V>) => {
  return (
    <FilterOptionWrapper className="filter-menu">
      {options.map(({ value, label }) => {
        const isSelected = selectedFilter === value
        return (
          <FilterOption
            className="filter-menu--filter-option"
            key={value}
            onClick={() => onChange(value)}
            selected={isSelected}
          >
            <Text
              color={light.dark900}
              fontStyle={FontStyle.bSmall}
              style={isSelected ? { fontWeight: 'bold' } : {}}
            >
              {label}
            </Text>
          </FilterOption>
        )
      })}
    </FilterOptionWrapper>
  )
}

export default FilterMenu
